import { trialsService } from '@/services/trials-service'
import { normalize, denormalize } from 'normalizr'
import { schemas } from '@/store/schemas'
import { MyActiveOrganization } from '@/helpers/my-account-helper'
import uuid from 'uuid'
import _ from 'lodash'

export const mutations = {
  ['FETCHING_TRIALS'](state, fetching) {
    state.fetchingTrials = fetching
  },
  ['SET_TRIALS'](state, trials) {
    let result = normalize(trials, schemas.organizationTrialList)
    state.trials = { ...state.trials, ...result.entities.trials }
    state.organizations = { ...state.organizations, ...result.entities.organizations }
    state.organizationTrials = {
      ...state.organizationTrials,
      ...result.entities.organizationTrials
    }
  },
  ['SET_TRIAL'](state, trial) {
    let result = normalize(trial, schemas.organizationTrial)
    state.trials = result.entities.trials
    state.organizations = result.entities.organizations
    state.organizationTrials = result.entities.organizationTrials
  },
  ['REFRESH_TRIALS'](state) {
    state.refreshTrials = uuid()
  }
}
export const actions = {
  async ['GET_TRIALS']({ commit }, params) {
    commit('FETCHING_TRIALS', true)
    const res = await trialsService.getTrials(MyActiveOrganization.id, params)
    commit('SET_TRIALS', res.data)
    commit('FETCHING_TRIALS', false)
    return res.data
  },
  async ['GET_TRIALS_PAGED']({ commit }, { params }) {
    commit('FETCHING_TRIALS', true)
    params = { ...params, ...{ paged: true } }
    const res = await trialsService.getTrials(MyActiveOrganization.id, params)
    commit('SET_TRIALS', res.data.content)
    commit('FETCHING_TRIALS', false)
    return res.data
  },
  async ['GET_TRIAL']({ commit }, { orgId, trialId }) {
    if (!_.isNil(trialId)) {
      const res = await trialsService.getTrial(orgId, trialId)
      commit('SET_TRIAL', res.data)
      return res.data
    }
  },
  async ['UPDATE_ORG_TRIAL']({ state, dispatch }, { orgId, organizationTrial, description }) {
    const orgTrial = denormalize(organizationTrial.id, schemas.organizationTrial, state)
    orgTrial.description = description
    const res = await trialsService.update(orgId, orgTrial.trial.id, orgTrial)
    dispatch('GET_TRIALS', orgId)
    return res.data
  },
  ['REFRESH_TRIALS']({ commit }) {
    commit('REFRESH_TRIALS')
  }
}

export const getters = {
  getTrialById: state => id => {
    return state.trials[id]
  },
  getOrganizationTrialByTrialId: state => trialId => {
    return _.values(state.organizationTrials).find(it => it.trial === trialId)
  },
  getOrganizationTrialViewModel: state => id => {
    if (id) {
      return denormalize(id, schemas.organizationTrial, state)
    }
    return _.map(_.keys(state.organizationTrials), it => {
      return denormalize(it, schemas.organizationTrial, state)
    })
  }
}
